/* JF 18 oct 2026 : texte court pour le bandeau cookies Shopify.
   Ne remplace que le texte par défaut de Shopify : si un texte est personnalisé dans l'admin, il est gardé. */
(function () {
  if (window.__jfShort) return;
  window.__jfShort = true;
  var SHORT = "Nous et nos partenaires (dont Shopify) utilisons des cookies pour mesurer l'audience et personnaliser la publicité, uniquement si vous acceptez. ";
  function shorten() {
    var p = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    if (!p) return false;
    if (p.getAttribute('data-jf-short')) return true;
    var txt = p.textContent.replace(/\s+/g, ' ').trim();
    if (!txt) return false;
    if (txt.indexOf('Nous et nos partenaires') !== 0 || txt.indexOf('Shopify') === -1 || txt.length < 200) return true;
    var link = p.querySelector('a');
    p.textContent = SHORT;
    if (link) p.appendChild(link);
    p.setAttribute('data-jf-short', '1');
    return true;
  }
  if (shorten()) return;
  var obs = new MutationObserver(function () { if (shorten()) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 20000);
})();

/* JF 18 oct 2026 : note dans Clarity le fichier à l'origine de chaque erreur JavaScript
   (filtre Clarity : étiquette personnalisée « jf_js_error »). Ne change rien pour le visiteur. */
(function () {
  if (window.__jfErrTag) return;
  window.__jfErrTag = true;
  var sent = 0;
  function tag(msg, src) {
    if (sent >= 5 || typeof window.clarity !== 'function') return;
    sent++;
    try {
      var s = (src || 'inline').replace(location.origin, '').split('?')[0].slice(-80);
      window.clarity('set', 'jf_js_error', (String(msg).slice(0, 60) + ' @ ' + s));
    } catch (e) {}
  }
  window.addEventListener('error', function (e) {
    if (e && e.target && e.target !== window && (e.target.src || e.target.href)) {
      tag('ressource introuvable', e.target.src || e.target.href);
    } else if (e) {
      tag(e.message, e.filename + ':' + e.lineno);
    }
  }, true);
  window.addEventListener('unhandledrejection', function (e) {
    var r = e && e.reason;
    tag((r && r.message) || r, (r && r.stack && (r.stack.match(/https?:\/\/[^\s)]+/) || [])[0]) || 'promesse');
  });
})();
